import React, { useState, createContext, useContext } from 'react';
import { MagnifyingGlass } from '@phosphor-icons/react';

const SearchContext = createContext({ searchTerm: '', setSearchTerm: () => {} });
export const useSearch = () => useContext(SearchContext);

const TAB_COLORS = {
  salaries_merged: '#002FA7',
  conges: '#2E7D32',
  maladie: '#C62828',
  validate: '#6A1B9A',
  company_docs: '#E65100',
  employee_docs: '#00695C',
  admin_docs: '#37474F',
  depenses: '#1565C0',
  notes_frais: '#00838F',
  tva: '#4E342E',
  chantiers: '#1565C0',
  facturation: '#2E7D32',
  courses: '#E65100',
  commandes: '#6A1B9A',
  project_docs: '#37474F',
  stocks: '#1565C0',
  materiel: '#E65100',
  vehicules: '#2E7D32',
  default: '#002FA7',
};

const VerticalTabs = ({ tabs, activeTab, onTabChange, children, hideNav = true }) => {
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <SearchContext.Provider value={{ searchTerm, setSearchTerm }}>
      <div style={{ display: 'flex', gap: '0', minHeight: '70vh' }} data-testid="vertical-tabs-container">
        {!hideNav && (
        <div style={{
          width: '220px', flexShrink: 0,
          borderRight: '1px solid #E2E2E6',
          backgroundColor: '#FAFAFA',
          borderRadius: '8px 0 0 8px',
          paddingTop: '8px',
          display: 'flex', flexDirection: 'column',
        }}>
          {tabs.map(tab => {
            const isActive = activeTab === tab.key;
            const color = TAB_COLORS[tab.key] || TAB_COLORS.default;
            const Icon = tab.icon;
            return (
              <button
                key={tab.key}
                onClick={() => { onTabChange(tab.key); setSearchTerm(''); }}
                data-testid={`tab-${tab.key}`}
                style={{
                  display: 'flex', alignItems: 'center', gap: '10px',
                  width: '100%', padding: '12px 16px',
                  border: 'none', cursor: 'pointer',
                  backgroundColor: isActive ? `${color}0D` : 'transparent',
                  borderLeft: isActive ? `3px solid ${color}` : '3px solid transparent',
                  borderRight: 'none',
                  color: isActive ? color : '#5E5F66',
                  fontWeight: isActive ? '700' : '400',
                  fontSize: '0.85rem',
                  transition: 'all 0.2s ease',
                  textAlign: 'left',
                  whiteSpace: 'nowrap',
                }}
              >
                {Icon && <Icon size={18} weight={isActive ? 'fill' : 'regular'} style={{ color: isActive ? color : '#9E9E9E', flexShrink: 0 }} />}
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{tab.label}</span>
                {tab.badge != null && tab.badge > 0 && (
                  <span style={{
                    marginLeft: 'auto', backgroundColor: color, color: 'white',
                    borderRadius: '10px', padding: '1px 7px', fontSize: '0.7rem', fontWeight: '700',
                    minWidth: '18px', textAlign: 'center'
                  }}>{tab.badge}</span>
                )}
              </button>
            );
          })}
        </div>
        )}
        <div style={{ flex: 1, padding: hideNav ? '0' : '0 0 0 24px', minWidth: 0 }}>
          {/* Search bar - icon in a fixed left compartment */}
          <div
            data-testid="tab-search-bar"
            style={{
              marginBottom: '16px',
              display: 'flex',
              alignItems: 'stretch',
              background: 'white',
              border: '1px solid #E2E2E6',
              borderRadius: 8,
              overflow: 'hidden',
              height: 38,
            }}
          >
            <div aria-hidden="true" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 38, background: '#F4F5F7', borderRight: '1px solid #E2E2E6', flexShrink: 0 }}>
              <MagnifyingGlass size={16} weight="bold" color="#5E5F66" />
            </div>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Rechercher..."
              style={{ flex: 1, border: 'none', outline: 'none', padding: '0 12px', fontSize: '0.92rem', background: 'transparent' }}
              data-testid="search-input"
            />
          </div>
          {children}
        </div>
      </div>
    </SearchContext.Provider>
  );
};

export { VerticalTabs, TAB_COLORS, SearchContext };
export default VerticalTabs;
